export const ASSIGN_DEALER_ACTIVATION = "ASSIGN_DEALER_ACTIVATION";
export const ASSIGN_DEALER_ACTIVATION_SUCCESSFULL = "ASSIGN_DEALER_ACTIVATION_SUCCESSFULL";
export const ASSIGN_DEALER_ACTIVATION_FAILED = "ASSIGN_DEALER_ACTIVATION_FAILED";
export const RESET_ASSIGN_DEALER = "RESET_ASSIGN_DEALER";
